import axios from "axios";
import { API_URL } from "./GlobalConstents";

const instance = axios.create({
  baseURL: API_URL,
  responseType: "json",
  timeout: 500000
});

// instance.defaults.headers.common["Devicetype"] = "3";
// instance.defaults.headers.common["Appversion"] = appVersion;

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if(userInfo && userInfo !== '') {
      config.headers.Accesstoken = userInfo;
    }
    
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
export default instance;